/*
 * LogoutPage.tsx
 * Handles the /logout route. Calls the logout API on mount then redirects to
 * /login, clearing the session cookie server-side before navigation.
 */

import { useEffect } from 'react';
import { signOut } from '../api/user';

export default function LogoutPage() {
  useEffect(() => {
    signOut()
      .catch(() => { /* ignore — session may already be expired */ })
      .finally(() => {
        window.location.href = '/login';
      });
  }, []);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <div className="spinner-border text-primary" role="status" aria-label="Signing out" />
    </div>
  );
}
